import { Button, Center, Switch, TextInput, Select } from "@mantine/core";
import { modals } from "@mantine/modals";

import { useCallback, useEffect, useState } from "react";

import { useLocation, useNavigate } from "react-router-dom";
import DeviceForm from "./DeviceForm";
import DeviceTable from "./DeviceTable";

import styled from "styled-components";
import { getStatusControlList, insertDevice, getControllerIdList } from "../apis/adminDeviceApis";
import { useRecoilState } from "recoil";
import { groupListState } from "components/Form/atom/groupListState";

function DeviceAddForm() {
  // eslint-disable-next-line no-unused-vars
  const [groupList, setGroupList] = useRecoilState(groupListState);
  const [controlList, setControlList] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [controlSelectedRecords, setControlSelectedRecords] = useState([]);
  const [statusSelectedRecords, setStatusSelectedRecords] = useState([]);
  const [defaultValues, setDefaultValues] = useState([]);
  const [controllerIdList, setControllerIdList] = useState([]); 
  const [,updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);

  const navigate = useNavigate();

  const location = useLocation();   //add bjkim6114
  let backPage = 1;
  let backGroup;
  if (location.state) {
    backPage = location.state.pg;
    backGroup = location.state.group;
  }
  if (location.state ) {
    backPage = location.state.pg;
  }

  const backToList = () => {
    const params = new URLSearchParams({page: String(backPage)});
    if (backGroup !== undefined && backGroup !== null) {
      params.set("group", backGroup);
    }
    navigate(`/admin/device?${params.toString()}`, {replace: true});
  };

  useEffect(() => {
    getControllerIdList(null).then((res) => {
      setControllerIdList(res);
    });
  }, []);

  useEffect(() => {
    getStatusControlList().then((res) => {
      setControlList(res?.ctrlList);
      setStatusList(res?.sttusList);
    });
  }, []);

  /** controlList, statusList을 selectedList 기반으로
   * chnnl_prcsdg를 "1"로 update 해주는 함수 */

  useEffect(() => {
    const filterAndSetRecords = (list, setRecords) => {
      const filteredList = list?.filter((record) => record?.chnnl_prcsdg === "1");
      setRecords(filteredList ?? []);
    };
    filterAndSetRecords(controlList, setControlSelectedRecords);
    filterAndSetRecords(statusList, setStatusSelectedRecords);
  }, [controlList, statusList]);

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(
      (pos) => {
        const lat = pos.coords.latitude;
        const lng = pos.coords.longitude;

        setDefaultValues({
          deviceName: "",
          location: { lat, lng },
          map_xcord: lng,
          map_ycord: lat,
        });
      },
      () => {
        setDefaultValues({
          deviceName: "",
          location: { lat: 35.8046406, lng: 128.7415048 },
          map_xcord: 128.7415048,
          map_ycord: 35.8046406,
        });
      }
    );
  }, []);

  const updateSelectRecords = () => {
    // 1. selectedControlState에 담긴 애들의 chnnl_prcsdg를 전부 "1"로 만듭니다.
    const newControlSelectedRecords = controlSelectedRecords.map((record) => ({
      ...record,
      chnnl_prcsdg: "1",
    }));

    // 2. controlState에 담긴 애들 중, selectedControlState에 담긴 애들을 제외한 나머지 애들의 chnnl_prcsdg를 전부 "0"으로 만듭니다.
    const selectedIds = newControlSelectedRecords.map((record) => record.chnnl_no);

    const newControlList = controlList.map((record) => {
      if (selectedIds.includes(record.chnnl_no)) {
        return {
          ...record,
          chnnl_prcsdg: "1",
        };
      } else {
        return {
          ...record,
          chnnl_prcsdg: "0",
        };
      }
    });

    // 3. statusSelectedRecords의 chnnl_prcsdg를 전부 "1"로 만듭니다.
    const newStatusSelectedRecords = statusSelectedRecords.map((record) => ({
      ...record,
      chnnl_prcsdg: "1",
    }));

    // 4. statusList 중, statusSelectedRecords에 담긴 애들을 제외한 나머지 애들의 chnnl_prcsdg를 전부 "0"으로 만듭니다.
    const selectedStatusIds = newStatusSelectedRecords.map((record) => record.chnnl_no);

    const newStatusList = statusList.map((record) => {
      if (selectedStatusIds.includes(record.chnnl_no)) {
        return {
          ...record,
          chnnl_prcsdg: "1",
        };
      } else {
        return {
          ...record,
          chnnl_prcsdg: "0",
        };
      }
    });
    return { newControlList, newStatusList };
  };


  const SetHistorical = (e,record) => {
    let historicalData = statusList?.find(item => item.chnnl_no === record.chnnl_no);
    historicalData.alar_at = e.currentTarget.checked ? 'Y' : 'N';
    forceUpdate();
  }

  const getSttusChnnlName = (e,record) => {
    let sttusChnnl = statusList?.find(item => item.chnnl_no === record.chnnl_no);
    sttusChnnl.chnnl_nm = e.target.value;
    forceUpdate();
  }

  const getCtrlChnnlName = (e,record) => {
    let ctrlChnnl = controlList?.find(item => item.chnnl_no === record.chnnl_no);
    ctrlChnnl.chnnl_nm = e.target.value;
    forceUpdate();
  }

  const statusOptions = (currentRecord, currentIndex) => {
    const selectedFeedbacks = controlList
      .filter((_, index) => index !== currentIndex)
      .map(item => item.feedback_ch?.toString())
      .filter(Boolean);

    return [
      {
        value: "",
        label: "",
      },
      ...statusList.map(item => ({
        value: item.chnnl_no.toString(),
        label: `${item.chnnl_no} - ${item.chnnl_nm}`,
        disabled: selectedFeedbacks.includes(item.chnnl_no.toString()),
      })),
    ];
  };

  const fields = [
    {
      key: "cntlr_id",
      name: "컨트롤러 아이디",
      type: "text",
    },
    {
      key: "bsd_nm",
      name: "장치명",
      type: "text",
    },
    {
      key: "group_id",
      name: "그룹선택",
      type: "select",
      options: groupList,
    },
    {
      key: "device_ip",
      name: "장치 IP",
      type: "text",
    },
    {
      key: "map_xcord",
      name: "경도",
      type: "text",
    },
    {
      key: "map_ycord",
      name: "위도",
      type: "text",
    },
    {
      key: "location",
      name: "지도",
      type: "map_picker",
      fullWidth: true,
    },
    {
      key: "model_nm",
      name: "모델명",
      type: "text",
    },
    {
      key: "makr_nm",
      name: "제조사",
      type: "text",
    },
    {
      key: "protocol",
      name: "프로토콜",
      type: "select",
      options: ["V 1.02"],
      defaultValue: "V 1.02",
    },
    {
      key: "instl_lc",
      name: "주소",
      type: "text",
      fullWidth: true,
      validate: (value) => {
        if (typeof value === "undefined" || !value) {
          return "주소를 입력해주세요.";
        }
        if (value.length < 6) {
          return "주소는 최소 6자 이상 입력해주세요.";
        }
      },
    },
    {
      key: "rm",
      name: "비고",
      type: "text",
      fullWidth: true,
    },
  ];

  const controlColumns = [
    {
      accessor: "index",
      title: "번호",
      textAlignment: "center",
      width: 30,
      render: (record) => controlList.indexOf(record) + 1,
      sortable: false,
    },
    {
      accessor: "chnnl_nm",
      title: "채널명",
      sortable: null,
      textAlignment: "center",
      render : (record) => (
        <TextInput
          placeholder="채널 명"
          value={record.chnnl_nm}
          onChange={(e) => getCtrlChnnlName(e,record)}
        />
      ),
    },
    {
      accessor: "chnnl_no",
      title: "채널번호",
      sortable: null,
      textAlignment: "center",
    },
    {
      accessor: "feedback_ch",
      title: "피드백 채널",
      sortable: null,
      textAlignment: "center",
      render: (record) => (
        <Select
          placeholder="피드백 채널 선택"
          value={record.feedback_ch?.toString() ?? null}
          data={statusOptions(record, controlList.indexOf(record))}
          onChange={(value) => {
            setControlList((prev) => {
              const next = prev.map((item) =>
                item.chnnl_no === record.chnnl_no
                  ? {
                      ...item,
                      feedback_ch: value ? Number(value) : null,
                    }
                  : item
              );

              return next;
            });
          }}
        />
      ),
    }
  ];

  const statusColumns = [
    {
      accessor: "index",
      title: "번호",
      textAlignment: "center",
      width: 30,
      render: (record) => statusList.indexOf(record) + 1,
    },
    {
      accessor: "chnnl_nm",
      title: "채널명",
      sortable: null,
      textAlignment: "center",
      render : (record) => (
        <TextInput
          placeholder="채널 명"
          value={record.chnnl_nm}
          onChange={(e) => getSttusChnnlName(e,record)}
        />
      ),
    },
    {
      accessor: "chnnl_no",
      title: "채널번호",
      sortable: null,
      textAlignment: "center",
    },
    {
      accessor: "alar_at",
      title: "상태이력 저장",
      sortable: null,
      textAlignment: "center",
      render : (record) => (
        <Switch onLabel="Yes" offLabel="No"
          size="md"
          label={record.alar_at}
          checked={record.alar_at === 'Y' ? true : false}
          onChange={(e) => SetHistorical(e,record)}
        />
      ),
    },
  ];

  const onSubmit = (e) => {
    console.log("e", e);
    modals.openConfirmModal({
      title: "저장",
      children: <Center>저장 하시겠습니까?</Center>,
    //  centered: true,
      zIndex: 2000,
      labels: { confirm: "저장", cancel: "취소" },
      onConfirm: () => {
        const isExistedId = controllerIdList.find(v => v.cntlr_id === e.cntlr_id);
        if ( !isExistedId ){
          const { newControlList, newStatusList } = updateSelectRecords();
          // 네이버 지도 좌표를 클릭하여 경도/위도 변경 후 저장시 숫자형으로 데이터가 전달되어 DB 저장이 되지 않아 문자로 변경하여 전달
          const payload = {
            ...e,
            map_xcord: e.map_xcord?.toString() ?? "",
            map_ycord: e.map_ycord?.toString() ?? "",
          };
          insertDevice(payload, newControlList, newStatusList, e.instl_lc);
          backToList();
        }
        else {
          alert("이미 존재하는 장치입니다 ");
        }
      },
    });
  };

  const SubmitButton = () => {
    return (
      <Center style={{ marginTop: "1rem" }}>
        <Button type="submit">저장</Button>
      </Center>
    );
  };

  return (
    <Styled.Grid>
      <DeviceForm fields={fields} onSubmit={onSubmit} submitButton={<SubmitButton />} defaultValues={defaultValues} />
      <div> [ 제어 채널 ]
        <DeviceTable
          searchBar
          data={controlList}
          columns={controlColumns}
          selectedRecords={controlSelectedRecords}
          setSelectedRecords={setControlSelectedRecords}
          idAccessor="chnnl_no"
        />
      </div>
      <div>[ 상태 채널 ]
        <DeviceTable
          searchBar
          data={statusList}
          columns={statusColumns}
          selectedRecords={statusSelectedRecords}
          setSelectedRecords={setStatusSelectedRecords}
          idAccessor="chnnl_no"
        />
      </div>
    </Styled.Grid>
  );
}

export default DeviceAddForm;

const Styled = {
  Grid: styled.div`
    display: grid;
    width: 100%;
    height: 100%;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: auto 1fr;
    grid-gap: 10px;

    & > div:nth-of-type(1) {
      grid-column: 1 / span 2;
    }
  `,
};
